export default {
  SET_IS_SHOWN: (state, boolean) => { state.isShown = boolean; },
  SET_MENU_ITEMS_LIST: (state, value) => { state.menuItemsList = value; },
};
